/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = RETAIL
 *
 * 1 = WHOLESALE
 *
 * 2 = FLEET
 *
 * 3 = LEASE
 *
 * 4 = ASSOCIATE
 *
 * 5 = PARTNER
 *
 * 6 = AUCTION
 *
 * 7 = DEALERTRF
 */
export enum SalesType {
  RETAIL = 0,
  WHOLESALE = 1,
  FLEET = 2,
  LEASE = 3,
  ASSOCIATE = 4,
  PARTNER = 5,
  AUCTION = 6,
  DEALERTRF = 7,
}
